import { useEffect, useRef } from "react";
import { Canvas } from "@templates";
import { useIsTeamsApp } from "src/hooks/useMsTeams";
import { getConsentUrlForCalendar, useAppDispatch } from "@lib/store";
import { authentication } from "@microsoft/teams-js";

// This component is here to redirect the user to the url where you authorize the calendar access. Outside the teams app this happens directly, but within the teams app, we need to open a custom popup window to do the redirects and only whitelisted urls you can open in these popups. So, this page functions as a whitelisted proxy.
export const TeamsCalendarConnect = () => {
  const isTeamsApp = useIsTeamsApp();
  const dispatch = useAppDispatch();
  const message = useRef("Initializing...");

  useEffect(() => {
    if (!isTeamsApp) return;

    message.current = "Checking redirect flow is completed...";
    // Get the params in the current url to check if we got redirected back from the consent flow
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("result") !== null) {
      const result: string = urlParams.get("result")!;
      message.current = "Redirect flow completed, closing window with result " + result + "...";

      // Notify the Teams SDK that we finished the authentication flow and pass the url params back to the parent window
      authentication.notifySuccess(result);
      return;
    } else {
      message.current = "Getting redirect URL...";
      // If we are not redirected back, start the calendar connect flow
      const handleCalendarConnect = async () => {
        const redirectUrl = await dispatch(getConsentUrlForCalendar()).unwrap();
        if (!redirectUrl) {
          message.current = "Failed to get redirect URL.";
          console.error("No redirect URL obtained for calendar consent");
          return;
        }
        message.current = "Redirecting to calendar consent...";
        document.location = redirectUrl;
      };

      handleCalendarConnect();
    }
  }, [isTeamsApp, dispatch]);

  return (
    <Canvas centerContent>
      <p>{message.current}</p>
    </Canvas>
  );
};
